export const prefix = 
    `You are a helpful assistant that is specialized in creating and organizing workshops and agendas. 
    Your task is to take the topic and build a workshop and output an agenda, by considering the duration and time. \n`;
export const output = `
Output a JSON that looks as follows: \n
{
    "numeric value that represents the day; start with 1": [
        {
            time: 'e.g. 09:00 - 10:00',
            title: 'Title of the current agenda',
            activities: ['activity 1', 'activity 2', 'activity 3']
        }
    ]
}
`;
export const output2 = `
Output a JSON that looks as follows: \n
{
    "numeric value that represents the day; start with 1": [
        {
            "time": 'e.g. 09:00 - 10:00',
            "title": 'Title of the current agenda'
        }
    ]
}
`;
export const outputActivity = `
Output a JSON that looks as follows: \n
{
    "numeric value that represents the day;": [
        {
            "time": "e.g. 09:00 - 10:00",
            "title": "Title of the current agenda",
            "activities": ["e.g. activity 1", "e.g. activity 2", "e.g. activity 3"]
        }
    ]
}
`;

export const activitiesPrefix = `We created a workshop agenda based on following input:
`;

export const activities = `
Your task is now to list for each segment activities that should be performed during that time in that workshop.
If there is no activity, make the list of activity empty. The following output should look as follows.
`;

export const outputActivities = `
Output a JSON that looks as follows: \n
{
  "09:00 - 10:00": [
    "Welcome and Introductions",
    "Overview of the Workshop",
    "Objectives of the Workshop"
  ],
  "10:00 - 10:15": [],
  "09:00 - 10:00": [
    "Overview of the current inventory projection process",
    "Challenges and issues with the current process",
    "Opportunities for improvement"
  ],
  ...
}
`;

export const examples = [
    `
      {
        "1": [
          {
            "time": "09:00 - 10:00",
            "title": "Introduction to the topic"
          },
          {
            "time": "10:00 - 11:00",
            "title": "How to increase transparency in inventory projection"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Case study: How an automotive supplier reduced its inventory by increasing transparency in its inventory projection"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Q&A"
          }
        ]
      }
    `,
    `
      {
        "1": [
            {
                "time": "09:00 - 10:00",
                "title": "Introduction to generative AI and PALM"
            },
            {
                "time": "10:00 - 11:00",
                "title": "Business use-cases for generative AI"
            },
            {
                "time": "11:00 - 12:00",
                "title": "Building intuitive software solutions with PALM"
            },
            {
                "time": "12:00 - 1:00",
                "title": "Lunch break"
            },
            {
                "time": "1:00 - 2:00",
                "title": "Demo of deployed products"
            },
            {
                "time": "2:00 - 3:00",
                "title": "Q&A"
            }
        ],
        "2": [
            {
                "time": "09:00 - 10:00",
                "title": "Advanced topics in generative AI"
            },
            {
                "time": "10:00 - 11:00",
                "title": "Technical deep dive into PALM"
            },
            {
                "time": "11:00 - 12:00",
                "title": "Hands-on workshop on building generative AI models with PALM"
            },
            {
                "time": "12:00 - 1:00",
                "title": "Lunch break"
            },
            {
                "time": "1:00 - 2:00",
                "title": "Continued hands-on workshop"
            },
            {
                "time": "2:00 - 3:00",
                "title": "Q&A"
            }
        ],
        "3": [
            {
                "time": "09:00 - 10:00",
                "title": "Presentation of final projects"
            },
            {
                "time": "10:00 - 11:00",
                "title": "Feedback and discussion"
            },
            {
                "time": "11:00 - 12:00",
                "title": "Wrap-up"
            },
            {
                "time": "12:00 - 1:00",
                "title": "Lunch break"
            },
            {
                "time": "1:00 - 2:00",
                "title": "Social event"
            },
            {
                "time": "2:00 - 3:00",
                "title": "Networking"
            }
        ]
      }
    `,
    `
      {
        "1": [
          {
            "time": "09:00 - 10:00",
            "title": "Introduction to Agile software development"
          },
          {
            "time": "10:00 - 11:00",
            "title": "Scrum framework"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Scrum roles and responsibilities"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Lunch break"
          }
        ],
        "2": [
          {
            "time": "09:00 - 10:00",
            "title": "Scrum ceremonies"
          },
          {
            "time": "10:00 - 11:00",
            "title": "Scrum artifacts"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Scrum practices"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Lunch break"
          }
        ],
        "3": [
          {
            "time": "09:00 - 10:00",
            "title": "Scrum retrospective"
          },
          {
            "time": "10:00 - 11:00",
            "title": "Scrum case study"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Q&A"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Wrap up"
          }
        ]
      }
    `,
    `
      {
        "1": [
          {
            "time": "09:00 - 10:00",
            "title": "Introduction to UI/UX design"
          },
          {
            "time": "10:00 - 11:00",
            "title": "The principles of user-centered design"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Designing for usability"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Lunch break"
          },
          {
            "time": "1:00 - 2:00",
            "title": "Designing for accessibility"
          }
        ]
      }
    `,
    `
      {
        "1": [
          {
            "time": "09:00 - 10:00",
            "title": "Introduction to Angular"
          },
          {
            "time": "10:00 - 11:00",
            "title": "Reusable Code Design Patterns"
          },
          {
            "time": "11:00 - 12:00",
            "title": "Angular Components"
          },
          {
            "time": "12:00 - 1:00",
            "title": "Lunch Break"
          },
          {
            "time": "1:00 - 2:00",
            "title": "Angular Services"
          },
          {
            "time": "2:00 - 3:00",
            "title": "Angular Modules"
          },
          {
            "time": "3:00 - 4:00",
            "title": "Angular Routing"
          },
          {
            "time": "4:00 - 5:00",
            "title": "Angular Testing"
          }
        ]
      }
    `
];


export const topic = `
We want to make use of generative AI and the given solution of Google PALM. 
The goal of the workshop is to find out business use-cases that leverages PALM and to build upon it software solution that are very intuitive for the user. 
At the end there should be multiple deployed products that may have some limitations and still can be improved but it should already be usable and testable by user. 
The product do not have to be tested by the end of the workshop. 
`
